import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

export const JSM_CREATE_FORM_TEMPLATE_CLIENT_ID: ClientId = client('jsm-create-form-template');
